import { render, staticRenderFns } from "./LiveForm.vue?vue&type=template&id=176c6ed3&scoped=true"
import script from "./LiveForm.vue?vue&type=script&lang=js"
export * from "./LiveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176c6ed3",
  null
  
)

export default component.exports